module.exports = __webpack_public_path__ + "static/media/identity.deee8658.svg";